// SIMULATOR
export const UPDATE_SIMULATOR_ACTIVED = 'UPDATE_SIMULATOR_ACTIVED'
export const UPDATE_SIMULATOR_RESULT = 'UPDATE_SIMULATOR_RESULT'
export const SIMULATOR_LOADING = 'SIMULATOR_LOADING'


// FAQ
export const UPDATE_FAQ = 'UPDATE_FAQ'
export const UPDATE_FAQ_QUESTION = 'UPDATE_FAQ_QUESTION'


// USER
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_IP = 'UPDATE_IP'

// SHARED
export const UPDATE_CITIES = 'UPDATE_CITIES'
export const UPDATE_REGION = 'UPDATE_REGION'
export const UPDATE_SEARCH_IDS = 'UPDATE_SEARCH_IDS'
export const UPDATE_SEARCH_ITEMS = 'UPDATE_SEARCH_ITEMS'
export const UPDATE_REGIONS_BY_CITY_SIMULATOR = 'UPDATE_REGIONS_BY_CITY_SIMULATOR'
export const UPDATE_REGIONS_BY_CITY_SIMPLE = 'UPDATE_REGIONS_BY_CITY_SIMPLE'
export const UPDATE_BRANCHES_BY_COORDS = 'UPDATE_BRANCHES_BY_COORDS'
export const UPDATE_BRANCHES_MAP_SUGGEST = 'UPDATE_BRANCHES_MAP_SUGGEST'
export const UPDATE_BRANCHES_BY_REGION = 'UPDATE_BRANCHES_BY_REGION'
export const UPDATE_REGION_BRANCHES = 'UPDATE_REGION_BRANCHES'
export const UPDATE_PHONE = 'UPDATE_PHONE'
export const UPDATE_REGIONS = 'UPDATE_REGIONS'
export const CONTACT_MODALS = 'CONTACT_MODALS'
export const CONTACT_MODALS_OPTIONS = 'CONTACT_MODALS_OPTIONS'
export const CONTACT_MODALS_HIGHLIGHT = 'CONTACT_MODALS_HIGHLIGHT'
export const UPDATE_MODAL_TOURS = 'UPDATE_MODAL_TOURS'
export const UPDATE_MODAL_GALLERY = 'UPDATE_MODAL_GALLERY'
export const INDICATE_FAIL_MESSAGE = 'INDICATE_FAIL_MESSAGE'
export const UPDATE_POLICIES = 'UPDATE_POLICIES'
export const UPDATE_SHOW_NEWSLETTER = 'UPDATE_SHOW_NEWSLETTER'

// PRODUCTS
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const UPDATE_LANDINGPAGE = 'UPDATE_LANDINGPAGE'
export const UPDATE_HOUSE_VIVAZ = 'UPDATE_HOUSE_VIVAZ'
export const UPDATE_LAST_PRODUCT_CITY = 'UPDATE_LAST_PRODUCT_CITY'
export const UPDATE_CUSTOM_LP = 'UPDATE_CUSTOM_LP'
export const UPDATE_PREVIOUS_PRODUCT = 'UPDATE_PREVIOUS_PRODUCT'
export const UPDATE_CURRENT_TOUR = 'UPDATE_CURRENT_TOUR'
export const UPDATE_CURRENT_GALLERY = 'UPDATE_CURRENT_GALLERY'

// HOME
export const UPDATE_HIGHLIGHT_PRODUCT = 'UPDATE_HIGHLIGHT_PRODUCT'
export const UPDATE_MANIFEST_VIDEO = 'UPDATE_MANIFEST_VIDEO'

// PRODUCTS
export const UPDATE_LOCATION_PRODUCT = 'UPDATE_LOCATION_PRODUCT'
export const UPDATE_RECREATION_PRODUCT = 'UPDATE_RECREATION_PRODUCT'
export const UPDATE_PLANT_PRODUCT = 'UPDATE_PLANT_PRODUCT'
export const UPDATE_FACILITIES_PRODUCT = 'UPDATE_FACILITIES_PRODUCT'
export const UPDATE_VIDEO_BY_ID_STATE = 'UPDATE_VIDEO_BY_ID_STATE'

// LOCATIONS
export const UPDATE_LOCATIONS = 'UPDATE_LOCATIONS'
export const UPDATE_NEIGHBORHOOD = 'UPDATE_NEIGHBORHOOD'

//ADVANTAGES
export const GET_ALL_ADVANTAGES = 'GET_ALL_ADVANTAGES'

//CAMPAIGNS
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN'



// WEBPACK FOOTER //
// ./src/store/constants.js